import { render, staticRenderFns } from "./DriverInfo.vue?vue&type=template&id=e349e8be&scoped=true"
import script from "./DriverInfo.vue?vue&type=script&lang=js"
export * from "./DriverInfo.vue?vue&type=script&lang=js"
import style0 from "./DriverInfo.vue?vue&type=style&index=0&id=e349e8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e349e8be",
  null
  
)

export default component.exports